import { createSelector } from 'reselect';

const selectServiceRequests = (state: any) => state.serviceRequests;

export const selectServiceRequestsCurrentItem = createSelector([selectServiceRequests], (serviceRequests) => serviceRequests.current);

export const selectServiceRequestsListItems = createSelector([selectServiceRequests], (serviceRequests) => serviceRequests.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectServiceRequestsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectServiceRequestsCreatedItem = createSelector([selectServiceRequests], (serviceRequests) => serviceRequests.create);

export const selectServiceRequestsUpdatedItem = createSelector([selectServiceRequests], (serviceRequests) => serviceRequests.update);

export const selectServiceRequestsReadItem = createSelector([selectServiceRequests], (serviceRequests) => serviceRequests.read);

export const selectServiceRequestsDeletedItem = createSelector([selectServiceRequests], (serviceRequests) => serviceRequests.delete);

export const selectServiceRequestsSearchedItems = createSelector([selectServiceRequests], (serviceRequests) => serviceRequests.search);

export const selectServiceRequestsItemsCount = createSelector([selectServiceRequests], (serviceRequests) => serviceRequests.count);

export const selectServiceRequestsItemsFilter = createSelector([selectServiceRequests], (serviceRequests) => serviceRequests.filter);